import { Link } from "react-router-dom";
import { SwissCross } from "@/components/Header";

export const AuthShell = ({ title, subtitle, children }) => (
  <div className="min-h-screen flex items-center justify-center p-6 bg-[#09090b] text-white relative overflow-hidden">
    <div className="absolute inset-0 pointer-events-none" style={{ backgroundImage: "radial-gradient(ellipse at top left, rgba(224,38,44,0.14), transparent 50%), radial-gradient(ellipse at bottom right, rgba(43,48,54,0.5), transparent 50%)" }} />
    <div className="relative w-full max-w-md z-10">
      <Link to="/" className="flex items-center gap-3 mb-10">
        <img src="/brand/aurora-mark.webp" alt="AURORA-ADV logo" className="w-10 h-10" />
        <div>
          <div className="font-display text-lg leading-none">Aurora<span className="aurora-text">-ADV</span></div>
          <div className="text-[10px] uppercase tracking-widest text-[#71717a] font-mono mt-1 flex items-center gap-1.5"><SwissCross className="w-2.5 h-2.5" /> Made in Switzerland</div>
        </div>
      </Link>
      <h1 className="font-display text-4xl mb-2">{title}</h1>
      <p className="text-sm text-[#a1a1aa] mb-8">{subtitle}</p>
      {children}
    </div>
  </div>
);
